import React from 'react';
import Layout from 'layout';

import { authenticationService } from 'auth/authenticationService.js'


import Factibilizaciones from 'pages/factibilizaciones/Factibilizaciones.js'

import { withRouter } from 'react-router-dom'
// import withRouter  from 'adds/router/withRouter.js';
import {
    Box,
    Typography,
    Paper,
    TextField, 
    // FormControl, MenuItem, Select, 
    Button, 
    // Divider,
    // InputLabel, FormHelperText, Grid,
    // Alert


} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

class Lista extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      html: {
        form:false,
        view: true,
        error_prt: null,
      },
      data:{
        nombre:'',
      },      
      permisos_en_lista:[],
      error:{
        nombre: false,
      },
      feedback:{
        patente: '',
        tipo:'',
        marca: '',
        modelo: '',
        transmision: '',
        color: '',
      },
      vehiculo_uuid_redirect:''
    };

    
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditForm = this.handleEditForm.bind(this);
    this.handleCancelEditForm = this.handleCancelEditForm.bind(this);
    this.handleLoadPermisos = this.handleLoadPermisos.bind(this);
    this.updateLista = this.updateLista.bind(this);


  }

  componentDidMount(){
    if(this.props.match.params.lista_uuid === 'new'){
      this.setState(prevState => ({ 
        html: { ...prevState.html,
                form: true,
                view: false,
        }
      }));
    }
    else{
      this.handleLoad();
    }
  }



  handleLoad(){
    authenticationService.fetchApi({
        url: '/permisos/lista/'+this.props.match.params.lista_uuid,
        method: 'GET',
    })
    .then(result => {
      this.setState({data:result},()=>{
        this.setState({
          html: {
            form:false,
            view:true,
          }
        });
      });
    })
    .catch(err => {

    });
  }

  handleLoadPermisos(){
    authenticationService.fetchApi({
      url: '/permisos/factibilizacion/?lista='+this.state.data.lista_uuid,
      method: 'GET',
    })
    .then(result => {
      this.setState({data:result},()=>{
        this.setState({
          html: {
            form:false,
            view:true,
            lista:true
          }
        });
      });
    })
    .catch(err => {

    });
  }

  handleInputChange(event) {
    const { data } = { ...this.state };
    const currentState = data;
    const { name, value } = event.target;
    currentState[name] = value;

    this.setState({ data: currentState });

  }

  handleSubmit(event) {
    event.preventDefault();

    let ok = true
    let error = this.state.error
    let feedback = this.state.feedback


    if(this.state.data.nombre===''||this.state.data.nombre===null){
      error['nombre']=true
      feedback['nombre']='Debes seleccionar un nombre para esta lista'
      ok = false
    }
    else{
      error['nombre']=false
      feedback['nombre']=''
    }

    if(!ok){
      return null;
    }

    this.setState({
      html: {
        form:false,
        view:true,
      }
    });

    authenticationService.fetchApi({
        url: '/permisos/lista/',
        method: 'POST',
        body: JSON.stringify(this.state.data),
    })
    .then((result)=>{
      this.props.history.push('/permisos/lista/'+result['lista_uuid']);
      
      this.setState({data:result});

    })
    .catch(err => {

    });
  }

  handleEditForm(event){

    event.preventDefault();
    this.setState({
      html: {
        form:true,
        view:false,
      }
    });

  }
  handleCancelEditForm(event){
    event.preventDefault();

    if(this.props.data.vehiculo_uuid === 'new'){
      this.props.history.push('/permisos/lista/');
    }
    else{
      this.handleLoad();
    }
    
    

  }

  updateLista(lista){
    this.setState({data:lista},()=>{
      console.log(this.state)
    })
  }




  render() {
    return (
      <Layout title='Lista Permisos'>


            {this.state.html.form &&

            <Box>

              <Box p={1}>
                <TextField  name='nombre'
                            id='nombre'
                            label='Nombre de la lista'
                            placeholder='Nombre de la lista'
                            fullWidth
                            maxLength='200'
                            value={this.state.data.nombre?this.state.data.nombre:''}
                            error={this.state.error.nombre}
                            helperText={this.state.feedback.nombre}
                            onChange={this.handleInputChange}
                            variant="standard"
                            />
              </Box>
              <Box p={1} textAlign='right'>
                <Button onClick={this.handleSubmit} color='primary' variant='contained'>Guardar Cambios</Button>
              </Box>

            </Box>
            }

            { this.state.html.view &&
            <Paper>

              <Box p={1} m={1}>
                <Box p={1} textAlign='right'>
                  <Button startIcon={<EditIcon/>} onClick={this.handleEditForm} color='primary' variant='contained'>Modificar datos de la lista</Button>
                </Box>
                <Box p={1}>
                  <Typography variant='caption' color='textSecondary'>
                    Nombre lista
                  </Typography>
                  <Box>
                    {this.state.data.nombre}
                  </Box>
                </Box>
              </Box>

            </Paper>
            }
            { this.state.html.view &&
              <Box>
                { this.state.data.lista_uuid && this.state.data.lista_uuid!== '' &&
                <Box>
                  <Factibilizaciones lista_uuid={this.state.data.lista_uuid} />
                </Box>
                }
              </Box>
            }
      </Layout>
    );
  }
}

export default withRouter(Lista);